import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../../../../../components";

export const ImageWrapper = styled(WrapperContainer)`
  width: 56px;
  height: 56px;

  min-width: 56px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const LinkText = styled(Paragraph2)`
  font-weight: 600;
`;

export const VersionInfo = styled(Paragraph2)`
  font-weight: 700;
`;

export const SummaryText = styled(Paragraph2)`
  text-align: center;
`;
